import { Navigate, useParams } from "react-router-dom"
import { LoadingState } from "~/components/screens/StateScreen"
import { authClient } from "~/lib/auth-client"
import { useLaunchPath } from "~/hooks/useLaunchPath"

export function OrgIndexRedirectPage() {
	const { orgSlug } = useParams<{ orgSlug: string }>()
	const { data: session, isPending } = authClient.useSession()
	const launch = useLaunchPath(session?.user.id, orgSlug)
	if (isPending || (session && launch.isLoading)) return <LoadingState />
	if (!session)
		return (
			<Navigate
				to={`/login?redirect_uri=${encodeURIComponent(`/${orgSlug ?? ""}`)}`}
				replace
			/>
		)
	if (!orgSlug || (launch.isSuccess && !launch.path))
		return <Navigate to="/" replace />
	return <Navigate to={launch.path ?? `/${orgSlug}/me/issues`} replace />
}
